export default {
    url: '/licencereport',
    template: '<reports-licencereport sites="vm.sites" classifiers="vm.classifiers" licences="vm.licences"/>',
    resolve: {
        sites: (SiteResource) => SiteResource.query({ reportUserLicenceSites: true, pageSize: 0 }).$promise,
        licences: (LicenceResource) => LicenceResource.query({ pageSize: 0, expand: 'licencePeriods' }).$promise
    },
    controller (classifiers, sites, licences) {
        this.classifiers = classifiers;
        this.sites = sites;
        this.licences = licences;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/licencereport/index.js